import { IInitOptions } from './types';
import { initialize } from './utils';

const PerfectTenseEditor = (options: IInitOptions) => {
  initialize(options);
};

export default PerfectTenseEditor;
